import axios from "axios";
import {TicketFilters} from "../Administrative/ticketsService";
import ticketInfo from "../../components/TicketInfo/TicketInfo";
const API_BASE_URL = process.env.REACT_APP_API_URL;

export interface TicketsResponse {
    tickets: any[];
    page: number;
    totalPages: number;
}

export const getTickets = async (
    page: number,
    filters: TicketFilters = {}
): Promise<TicketsResponse> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/tickets/technician`, {
            params: {page, size: 10, ...filters},
            withCredentials: true
        });
        const transformedTickets = response.data.data.tickets.content.map((item: any) => ({
            CLIENTE: item.client,
            PLANTA: item.plant,
            SERVICIO: item.service,
            ESTADO: item.state,
            'CLAVE DE TICKET': item.uniqueCode,
        }))
        return {
            tickets: transformedTickets || [],
            page: response.data.data.tickets.number,
            totalPages: response.data.data.tickets.totalPages,
        };
    } catch (error) {
        throw error;
    }
};

export const addPerformedActions = async (performedActions: any, ticketUniqueCode: string) => {
    try {
        await axios.put(`${API_BASE_URL}/tickets/performedActions/${ticketUniqueCode}`, {performedActions} , {withCredentials: true});
    } catch (error) {
        throw error;
    }
}